import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import get from 'lodash/get';
import classNames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import ContentGroup from '../content-group';
import { CustomThemeContext } from '../../context';
import CallToActionWrapper from '../call-to-action-wrapper';
import Markdown from '../markdown/index';
import Module from './module';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NOT_FOUND = -1;

const Modules = _ref => {
  let {
    className,
    modules,
    initialColor,
    initialAngle,
    centreTitle,
    children = null,
    basicContentFullWidthCtaOnMobile
  } = _ref;
  let color = initialColor === 'White' ? 'Grey' : 'White';
  let angle = initialAngle === 'top-left' ? 'top-right' : 'top-left';
  return /*#__PURE__*/_jsx(CustomThemeContext.Consumer, {
    children: themeOption => /*#__PURE__*/_jsx("div", {
      className: classNames(className, style.moduleGroup, style.evolved),
      "data-id": "modules_index_Modules_div",
      children: modules.map((module, i) => {
        color = color === 'White' ? 'Grey' : 'White';
        angle = angle === 'top-left' ? 'top-right' : 'top-left';
        const moduleId = get(module, 'sys.id');
        const moduleType = get(module, 'sys.contentTypeId');
        const displayMode = get(module, 'displayMode');

        switch (moduleType) {
          case 'section':
            {
              angle = 'top-left';
              const isPageHeading = module.displayMode === 'Page Heading';
              let headingColor = 'Seasonal';

              if (module.displayMode === 'Section Heading' && themeOption.luxury) {
                headingColor = color;
              }

              return /*#__PURE__*/_jsx("div", {
                className: classNames(style.moduleListSection, {
                  [style.pageHeading]: isPageHeading
                }),
                "data-id": "modules_index_Modules_div_1",
                children: /*#__PURE__*/_jsx(Module, {
                  lazyLoad: i > 0,
                  moduleProps: _objectSpread(_objectSpread({}, module), {}, {
                    color: headingColor
                  }),
                  "data-id": "modules_index_Modules_div_Module"
                })
              }, "module-".concat(i));
            }

          case 'introductions':
            color = 'White';
            return /*#__PURE__*/_jsx("div", {
              className: style.moduleListFeature,
              "data-id": "modules_index_Modules_div",
              children: /*#__PURE__*/_jsx(Module, {
                lazyLoad: i > 0,
                moduleProps: _objectSpread(_objectSpread({}, module), {}, {
                  angleOrigin: angle
                }),
                "data-id": "modules_index_Modules_div_Module"
              })
            }, "module-".concat(i));

          case 'utilityPanel':
            {
              return /*#__PURE__*/_jsx("div", {
                className: style.moduleListSection,
                "data-id": "modules_index_Modules_div",
                children: /*#__PURE__*/_jsx(Module, {
                  lazyLoad: i > 0,
                  moduleProps: _objectSpread(_objectSpread({}, module), {}, {
                    angleOrigin: angle,
                    color,
                    origin: 'modules'
                  }),
                  "data-id": "modules_index_Modules_div_Module"
                })
              }, "module-".concat(i));
            }

          case 'basicContent':
            {
              return /*#__PURE__*/_jsxs("div", {
                "data-id": "modules_index_Modules_div",
                children: [/*#__PURE__*/_jsx(Paragraph, {
                  "data-id": "modules_index_Modules_div_Paragraph",
                  children: module.bodyCopy
                }), module.callsToAction.map(cta => /*#__PURE__*/_jsx(CallToActionWrapper, {
                  url: cta.address,
                  category: cta.category,
                  className: classNames(style.moduleCta, {
                    [style.fullWidthCtaOnMobile]: basicContentFullWidthCtaOnMobile
                  }),
                  "data-id": "modules_index_Modules_CallToActionWrapper"
                }, cta.id))]
              }, "module-".concat(i));
            }

          case 'contentBlock':
            {
              return /*#__PURE__*/_jsx("div", {
                "data-id": "modules_index_Modules_div",
                children: /*#__PURE__*/_jsx(Markdown, {
                  content: module.bodyCopy,
                  "data-id": "modules_index_Modules_Markdown"
                })
              }, "module-".concat(i));
            }

          case 'dynamicContent':
            return /*#__PURE__*/_jsx("div", {
              "data-id": "modules_index_Modules_div",
              children: children
            }, "module-".concat(i));

          case 'promotion':
          case 'manualCollection':
          case 'automatedCollection':
          default:
            if (displayMode === 'Deck') {
              if (!themeOption.luxury) {
                color = 'Seasonal';
              }
            }

            if (['Page Heading', 'Section Heading'].indexOf(displayMode) > NOT_FOUND) {
              angle = 'top-left';
              const isSectionHeading = displayMode === 'Section Heading';
              let headingColor = 'Seasonal';

              if (isSectionHeading && themeOption.luxury) {
                headingColor = color;
              }

              return /*#__PURE__*/_jsx("div", {
                className: classNames(style.moduleListSection, {
                  [style.sectionHeading]: isSectionHeading
                }),
                "data-id": "modules_index_Modules_div_13",
                children: /*#__PURE__*/_jsx(Module, {
                  lazyLoad: i > 0,
                  moduleProps: _objectSpread(_objectSpread({}, module), {}, {
                    color: headingColor
                  }),
                  "data-id": "modules_index_Modules_div_Module"
                })
              }, "module-".concat(i));
            }

            if (displayMode === 'Feature') {
              color = 'White';
              return /*#__PURE__*/_jsx("div", {
                className: style.moduleListFeature,
                "data-id": "modules_index_Modules_div",
                children: /*#__PURE__*/_jsx(Module, {
                  lazyLoad: i > 0,
                  moduleProps: _objectSpread(_objectSpread({}, module), {}, {
                    angleOrigin: angle
                  }),
                  "data-id": "modules_index_Modules_div_Module"
                })
              }, "module-".concat(i));
            }

            if (displayMode === 'Featured Content') {
              color = 'Transparent';
              angle = 'none';
            }

            return /*#__PURE__*/_jsx(ContentGroup, {
              angleOrigin: angle,
              color: color,
              backgroundImage: false,
              "data-id": "modules_index_Modules_ContentGroup",
              children: /*#__PURE__*/_jsx(Module, {
                lazyLoad: i > 0,
                moduleProps: _objectSpread(_objectSpread({}, module), {}, {
                  angleOrigin: angle,
                  color,
                  centreTitle
                }),
                "data-id": "modules_index_Modules_ContentGroup_Module"
              })
            }, "module-".concat(moduleId || i));
        }
      })
    })
  });
};

Modules.defaultProps = {
  initialColor: 'Grey',
  initialAngle: 'top-left',
  basicContentFullWidthCtaOnMobile: false
};
export default Modules;